import { colorHexFor } from '../lib/colors';

/**
 * ProjectColorBar — the project-color stripe used at the top of the page
 * + per-card on the main app. The portal uses 12px at the very top of the
 * project page (echoing the main app's Notes-page chrome from ARCH §3.5).
 */
export function ProjectColorBar({
  colorTag,
  height = 12,
  className,
}: {
  colorTag: string | null | undefined;
  height?: number;
  className?: string;
}) {
  return (
    <div
      className={className}
      style={{ height: `${height}px`, background: colorHexFor(colorTag), width: '100%' }}
      aria-hidden="true"
    />
  );
}
